import React, { PureComponent } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";

const responsive = () => {
  return `
    max-width: 100%;
    height: auto;
    display: inline-block;
  `;
};

const StyledImage = styled.img`
  ${p => cssMainSelector(p.theme.tdsId)} {
    ${p => p.responsive && responsive()};
  }
`;

class Image extends PureComponent {
  render() {
    const { alt, responsive, title } = this.props;

    try {
      return (
        <StyledImage
          responsive={responsive}
          src={this.imageSrc()}
          alt={alt}
          title={title}
        />
      );
    } catch (e) {
      return null;
    }
  }

  imageSrc() {
    const { src } = this.props;

    if (src.indexOf("://") >= 0) {
      return src;
    } else {
      return `${require("../images/" + src)}`;
    }
  }
}

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  responsive: PropTypes.bool,
  src: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default Image;
